__turbopack_context__.v({
  "activeTabDot": "PerformanceLabNavbar-module__1nZkda__activeTabDot",
  "activeTabLabel": "PerformanceLabNavbar-module__1nZkda__activeTabLabel",
  "backArrow": "PerformanceLabNavbar-module__1nZkda__backArrow",
  "desktopTabs": "PerformanceLabNavbar-module__1nZkda__desktopTabs",
  "exploreCta": "PerformanceLabNavbar-module__1nZkda__exploreCta",
  "homeBackLabel": "PerformanceLabNavbar-module__1nZkda__homeBackLabel",
  "logoLink": "PerformanceLabNavbar-module__1nZkda__logoLink",
  "menuIcon": "PerformanceLabNavbar-module__1nZkda__menuIcon",
  "menuToggle": "PerformanceLabNavbar-module__1nZkda__menuToggle",
  "mobileMenuDivider": "PerformanceLabNavbar-module__1nZkda__mobileMenuDivider",
  "mobileTabItem": "PerformanceLabNavbar-module__1nZkda__mobileTabItem",
  "mobileTabsRow": "PerformanceLabNavbar-module__1nZkda__mobileTabsRow",
  "navBackdrop": "PerformanceLabNavbar-module__1nZkda__navBackdrop",
  "navInner": "PerformanceLabNavbar-module__1nZkda__navInner",
  "navRoot": "PerformanceLabNavbar-module__1nZkda__navRoot",
  "rightActions": "PerformanceLabNavbar-module__1nZkda__rightActions",
  "tabActive": "PerformanceLabNavbar-module__1nZkda__tabActive",
  "tabLink": "PerformanceLabNavbar-module__1nZkda__tabLink",
  "topRow": "PerformanceLabNavbar-module__1nZkda__topRow",
});
